module.exports = __webpack_public_path__ + "img/1.58643947.png";